module.exports = ".m-list{    \r\n    list-style: none;\r\n    height: 130px !important;\r\n    min-height: 130px !important;\r\n    overflow-y: auto;\r\n    background: #f4f4f4 !important;\r\n    padding: 0px !important;\r\n}\r\n.m-list li {\r\n    font-weight: normal;\r\n    display: block;\r\n    white-space: pre;\r\n    min-height: 1.2em;\r\n    padding: 0px 2px 1px;\r\n    cursor: pointer;\r\n}\r\n.option-selected{\r\n    background: lightgray !important;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-controls/multi-select/multi-select.component.css
// module id = ./src/app/user-controls/multi-select/multi-select.component.css
// module chunks = main